export default {
    // --------Title--------
    information: 'Information',
    profileDataDetails: 'Profile data details',
    scopes: 'Scopes',
    groupingDataRange: 'Grouping data range',
    
    // --------MUI--------
    actionType: 'Action Type',
    owners: 'Owners',
    users: 'Users',

};